import "./styles.less";

import { Button, Grid } from "antd";
import { MouseEvent, useContext, useEffect, useRef, useState } from "react";

import { ModalWpp } from "../../../ModalWpp/web";
import { WhatsAppOutlined } from "@ant-design/icons";
import { useFacebookPixel } from "../../../../../GlobalHooks/web/FacebookPixel.hook";
import { useRouter } from "next/router";
import { OwnerWspInterface, useWhatsppButton } from "../../../InformationRequest/LeadButtons/WhatsappButton/hook";
import { ModalState } from "shared-components/Components/Property/InformationRequest/TextForm/type";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { LoadingIcon } from "shared-components/Components/CustomIcons/LoadingIcon/LoadingIcon";

export const WhatsappButton = ({ 
	listing, 
	mode, 
	text= '',
	disabled = false, 
	btnType = "default",
	queryRouter, 
	onWpClick, 
	forceState = ModalState.DEFAULT 
}: OwnerWspInterface) => {
	const FP = useFacebookPixel();
	const callWpp = useRef(null);
	const [modal, setModal] = useState(false);

	const {
		viewWpp,
		loading,
	} = useWhatsppButton(listing?.id);

	const { has_whatsapp, name: owner_name  } = listing?.owner;

	const [wppPhone, setWppPhone] = useState<string>("");
	const [linkWpp, setLinkWpp] = useState<string>("");

	const { main_domain, country_code } = useContext(ConfigStateContext);

	// Simula el click de ver "Whatsapp"
	useEffect(() => {
		setTimeout(() => {
			if (queryRouter && queryRouter === "wpp") {
				if (callWpp.current) callWpp.current.click();
			}
		}, 3000);
	}, [queryRouter]);

	useEffect(() => {
		if (forceState == ModalState.CLOSE) {
			setModal(false);
		} else if (forceState == ModalState.OPEN) {
			setModal(true);
		}
	}, [forceState]);

	const sendEvent = () => {
		const categoryName: string = "Consultas Wpp";
		FP.StandardEvent(categoryName);
	};

	const handleClick = (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();

		if (has_whatsapp) {
			const type = listing.isProject ? "PROJECT" : "PROPERTY";

			viewWpp(type).then(data => {
				if (data) {
					sendEvent();
					setModal(true);
					setWppPhone(data?.data?.requestPhone);
				}
			});
		} else {
			setModal(true);
			sendEvent();
		}
	};

	useEffect(()=>{
		const mensaje = encodeURIComponent(`Hola, ví esta propiedad en ${country_code!=='ce3'?'InfoCasas': 'Casas en el Este'} y me gustaría tener más información. ${listing?.title} https://${main_domain}${listing?.link}`);
		setLinkWpp(`https://api.whatsapp.com/send?phone=${wppPhone}&text=${mensaje}&app_absent=1`)
	}, [wppPhone])

	return (
		<>
			<button
				ref={callWpp}
				className="wpp-button"
				disabled={disabled}
				onClick={handleClick}
			>
				{loading ? (
					<LoadingIcon classes="loading-icon" width={16} />
				) : (
					<span className="btn-icon"><WhatsAppOutlined /></span>
				)}
				<span className="btn-text">{text ? text: ''}</span>
			</button>
			<ModalWpp
				mode={mode}
				visible={modal}
				owner={listing?.owner}
				property_code={listing?.code}
				width={620}
				link={linkWpp}
				property_id={listing?.id}
				phone={wppPhone}
				loading={loading}
				onWpClick={onWpClick}
				owner_name={owner_name}
				onCancel={() => setModal(false)}
				icon={<WhatsAppOutlined />}
			/>
		</>
	);
};

